module.exports = __webpack_public_path__ + "img/googlemybusiness-instruction-1.88f7b62b.png";